import { render, staticRenderFns } from "./OptionsPrescriber.vue?vue&type=template&id=c849fd4c&scoped=true&"
import script from "./OptionsPrescriber.vue?vue&type=script&lang=ts&"
export * from "./OptionsPrescriber.vue?vue&type=script&lang=ts&"
import style0 from "./OptionsPrescriber.vue?vue&type=style&index=0&id=c849fd4c&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c849fd4c",
  null
  
)

export default component.exports